import React from "react";
import { Flame, TextSearch } from "lucide-react";
import LooksAlikeIcon from "@/assets/svg/Looks-alike";
import MatchedIntentIcon from "@/assets/svg/MatchedIntentIcon";

/** Strip markdown links, bare URLs, and leftover punctuation from display text. */
export const getCleanPlainText = (input = "") => {
  if (input == null || input === "") return "";

  let text = String(input);
  text = text.replace(/\[([^\]]*)\]\([^)]*\)/g, "");
  text = text.replace(/https?:\/\/[^\s)]+/gi, "");
  text = text.replace(/\(\s*\)/g, "");
  text = text.replace(/\s{2,}/g, " ");
  text = text.replace(/,\s*,/g, ",");
  text = text.replace(/,\s*$/g, "");

  return text.trim();
};

export const getDisplayLocation = (input = "") => {
  const text = getCleanPlainText(input);
  return !text || /^(unknown|n\/?a|not available|unavailable|not identified)$/i.test(text)
    ? "Not Identified"
    : text;
};


// get clean name from domain
export const getCleanName = (input = "") => {
  if (!input) return "";

  try {
    let url = input.trim().toLowerCase();

    if (!url.startsWith("http")) {
      url = "https://" + url;
    }

    const hostname = new URL(url).hostname;
    const cleanHost = hostname.replace(/^www\./, "");
    const baseName = cleanHost.split(".")[0];

    return decodeURIComponent(baseName)
      .split("-")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  } catch {
    return decodeURIComponent(input)
      .split("-")
      .filter(Boolean)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
};


// get touch point type options
export const TOUCH_POINT_TYPE_OPTIONS = [
  {
    label: "Call",
    value: "call",
  },
  {
    label: "Email",
    value: "email",
  },
  {
    label: "Meeting",
    value: "meeting",
  },
  {
    label: "WhatsApp",
    value: "whatsapp",
  },
  {
    label: "LinkedIn",
    value: "linkedin",
  },
  {
    label: "Other",
    value: "other",
  },
];


// whom to remind options
export const WHOM_TO_REMIND_OPTIONS = [
  {
    label: "Me (Internal Reminder)",
    value: "me",
  },
  // {
  //   label: "External Reminder",
  //   value: "external",
  // },
];


// account discovery tabs

export const AccountDiscoveryTabs = [
  {
    key: "custom_search",
    title: "Custom Search",
    icon: <TextSearch size={16} strokeWidth={2} />,
  },
  {
    key: "find_look_alikes",
    title: "Find look-alikes",
    icon: <LooksAlikeIcon size={16} className="w-4 h-4 text-current shrink-0" />,
  },
  {
    key: "most_engaged_plus_likely_to_win",
    title: "Most engaged + likely to win",
    icon: <Flame size={16} strokeWidth={2} />,
  },
  {
    key: "intent_matched",
    title: "Intent Matched Accounts",
    disabled: true,
    badge: "Coming soon",
    icon: <MatchedIntentIcon size={16} className="w-4 h-4 text-current shrink-0" />,
  },
];


// account discover suggestions


export const ACCOUNT_DISCOVER_SUGGESTIONS = [
  {
    label: "D2C skincare brands in india with 100-200 employees that raised funding in the last 6 months",
    value: "d2c_skincare_brands_in_india_with_100_200_employees_that_raised_funding_in_the_last_6_months",
  },
  {
    label: "Manufacturing companies in India with 500+ employees that announced a new plant or expansion",
    value: "manufacturing_companies_in_india_with_500_employees_that_announced_a_new_plant_or_expansion",
  },
  {
    label: "Fintech and NBFC companies in Mumbai and Bengaluru hiring for sales or growth roles",
    value: "fintech_nbfc_companies_mumbai_bengaluru_hiring_sales_growth_roles",
  }
];

